import { defineMessages } from "react-intl";
const messages = defineMessages({
    editFloorplanTitle: {
        id: "app.common.components.floorplanEditor.editFloorplanTitle.text",
        defaultMessage: "Edit Floorplan",
    },
    select: {
        id: "app.common.components.floorplanEditor.select.text",
        defaultMessage: "Select",
    },
    wall: {
        id: "app.common.components.floorplanEditor.wall.text",
        defaultMessage: "Wall",
    },
    door: {
        id: "app.common.components.floorplanEditor.door.text",
        defaultMessage: "Door",
    },
    window: {
        id: "app.common.components.floorplanEditor.window.text",
        defaultMessage: "Window",
    },
    draw: {
        id: "app.common.components.floorplanEditor.draw.text",
        defaultMessage: "Draw",
    },
    text: {
        id: "app.common.components.floorplanEditor.text.text",
        defaultMessage: "Text",
    },
    rectangle: {
        id: "app.common.components.floorplanEditor.rectangle.text",
        defaultMessage: "Rectangle",
    },
    thickness: {
        id: "app.common.components.floorplanEditor.thickness.text",
        defaultMessage: "Thickness",
    },
    wallWidth: {
        id: "app.common.components.floorplanEditor.wallWidth.text",
        defaultMessage: "Wall Width:",
    },
    brushWidth: {
        id: "app.common.components.floorplanEditor.brushWidth.text",
        defaultMessage: "Brush Width:",
    },
    color: {
        id: "app.common.components.floorplanEditor.color.text",
        defaultMessage: "Color",
    },
    enterText: {
        id: "app.common.components.floorplanEditor.enterText.text",
        defaultMessage: "Enter text",
    },
    addText: {
        id: "app.common.components.floorplanEditor.addText.text",
        defaultMessage: "Add Text",
    },
    addRectangle: {
        id: "app.common.components.floorplanEditor.addRectangle.text",
        defaultMessage: "Add Rectangle",
    },
    deleteSelected: {
        id: "app.common.components.floorplanEditor.deleteSelected.text",
        defaultMessage: "Delete Selected",
    },
    save: {
        id: "app.common.components.floorplanEditor.save.text",
        defaultMessage: "Save",
    },
    download: {
        id: "app.common.components.floorplanEditor.download.text",
        defaultMessage: "Download",
    },
    cancel: {
        id: "app.common.components.floorplanEditor.cancel.text",
        defaultMessage: "Cancel",
    },
    clickToPlaceDoor: {
        id: "app.common.components.floorplanEditor.clickToPlaceDoor.text",
        defaultMessage: "Click on canvas to place door",
    },
    clickToPlaceWindow: {
        id: "app.common.components.floorplanEditor.clickToPlaceWindow.text",
        defaultMessage: "Click on canvas to place window",
    },
    zoomIn: {
        id: "app.common.components.floorplanEditor.zoomIn.text",
        defaultMessage: "Zoom In",
    },
    zoomOut: {
        id: "app.common.components.floorplanEditor.zoomOut.text",
        defaultMessage: "Zoom Out",
    },
});
export default messages;
